export default __webpack_public_path__ + "static/car-orange-9623e92ea531d58cd7e1ad5394fc7634.svg";